import { render, staticRenderFns } from "./skills-card-form-sms-send.vue?vue&type=template&id=58d6bf36&"
import script from "./skills-card-form-sms-send.vue?vue&type=script&lang=js&"
export * from "./skills-card-form-sms-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports